export default __webpack_public_path__ + "static/media/thor.1317bafe.png";